// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__nq2Zq","trigger":"Navigation_trigger__kPHb6","trigger__active":"Navigation_trigger__active__0uvkO"};